import {NgModule} from '@angular/core';
import {AzoraInput} from './input';
import {CommonModule} from '@angular/common';
import {PortalModule} from "@angular/cdk/portal";
import {AzoraSlotModule, AzoraMaskModule, AzoraRippleModule, AzoraProgressModule} from "@azora/core";


@NgModule({
    declarations: [
        AzoraInput
    ],
    imports: [
        CommonModule,
        PortalModule,
        AzoraSlotModule,
        AzoraMaskModule,
        AzoraRippleModule,
        AzoraProgressModule
    ],
    exports: [
        AzoraInput
    ],
    entryComponents: [AzoraInput]
})
export class AzoraInputModule {
}
